import React, { Component } from 'react';
import Modal from './_Modal';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 120px;
`

class LoadingModal extends Component {
  constructor() {
    super()
    this.state = { dots: '', open: false }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.open) {
      this.setState({ open: true });
      this.addDot();
    }
  }
  //   if (nextProps.open) {
  //     setTimeout(() => {
  //       nextProps.closeModal(nextProps.method)
  //     }, 1000);
  //   }
  // }
  addDot = () => {
    if (this.props.open) {
      this.setState({ dots: this.state.dots.length < 3 ? this.state.dots + '.' : '' })
      window.setTimeout(this.addDot, 200)
    } else {
      this.setState({ open: false })
    }
  }
  componentDidMount() {
    this.addDot();
    // window.setTimeout(() => {
    //   this.setState({ dots: this.state.dots.length < 3 ? this.state.dots + '.' : '' })
    // }, 500)
  }
  render() {
    return (
        <Modal
          open={this.state.open}
          close={() => this.props.closeModal(this.props.method)}
        >
          <Wrapper>
            <h3>{'Working' + this.state.dots}</h3>
          </Wrapper>
        </Modal>
    )
  }
}

export default LoadingModal;



// WEBPACK FOOTER //
// ./src/_LoadingModal.js